/**
 * Blog product row — add to cart straight from an article page.
 *
 * Delegated, so it survives rows being re-rendered by the theme editor.
 * Fires the same 'product:added' event the theme's product form fires, which is
 * what makes the mini-cart re-render and open.
 */
(function () {
  'use strict';

  var RESET_DELAY = 2200;

  // ── placement ───────────────────────────────────────────────────────────────
  // The row is rendered hidden at the top of the article body and moved into the
  // copy from here, because only the rendered DOM knows where the images are.
  // Constraints: after at least N paragraphs of real text, never directly above
  // or below an image, and never so far down that it collides with the row that
  // sits at the end of the post.
  var MIN_TEXT_LENGTH = 40;   // ignore captions and one-line stubs
  var MAX_DEPTH = 0.6;        // stay within the first 60% of the article

  function holdsImage(el) {
    if (!el) return false;
    return el.tagName === 'IMG' ||
      el.tagName === 'FIGURE' ||
      el.tagName === 'PICTURE' ||
      !!el.querySelector('img, picture, video, iframe');
  }

  function isProse(el) {
    if (!el || holdsImage(el)) return false;
    if (el.tagName !== 'P' && el.tagName !== 'OL' && el.tagName !== 'UL') return false;
    return (el.textContent || '').trim().length >= MIN_TEXT_LENGTH;
  }

  function findSlot(blocks, limit, minParagraphs, avoidImageBelow) {
    var prose = 0;

    for (var i = 0; i < blocks.length && i < limit; i++) {
      if (isProse(blocks[i])) prose++;
      if (prose < minParagraphs) continue;

      if (holdsImage(blocks[i])) continue;                              // never directly under an image
      if (avoidImageBelow && holdsImage(blocks[i + 1])) continue;       // ideally not directly over one either

      return blocks[i];
    }

    return null;
  }

  function placeRow(row) {
    if (row.hasAttribute('data-blog-row-placed')) return;
    row.setAttribute('data-blog-row-placed', '');

    var body = row.closest('.Article__Body');
    if (!body) { row.removeAttribute('hidden'); return; }

    var minParagraphs = parseInt(row.getAttribute('data-blog-row-place'), 10) || 1;

    var blocks = Array.prototype.filter.call(body.children, function (el) {
      return el !== row && el.nodeType === 1;
    });

    var limit = Math.max(1, Math.floor(blocks.length * MAX_DEPTH));

    // Two passes. Ideally the row touches no image at all. But plenty of posts here
    // are one intro paragraph followed by nothing but photos, and a strict rule
    // leaves those with no row at all — so fall back to allowing a photo *below*
    // the row. Sitting directly under an image is the ugly one (the row butts
    // against the photo edge), and that stays banned either way.
    var target = findSlot(blocks, limit, minParagraphs, true) ||
                 findSlot(blocks, limit, minParagraphs, false);

    if (!target) return; // genuinely nowhere sensible — leave it hidden rather than dump it somewhere ugly

    target.parentNode.insertBefore(row, target.nextSibling);
    row.removeAttribute('hidden');
  }

  function placeAll() {
    var rows = document.querySelectorAll('[data-blog-row-place]');
    for (var i = 0; i < rows.length; i++) placeRow(rows[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeAll);
  } else {
    placeAll();
  }

  // Re-place after the theme editor re-renders the section, otherwise the row
  // stays hidden the moment a merchant touches any setting.
  document.addEventListener('shopify:section:load', placeAll);

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-blog-row-add]');
    if (!btn || btn.disabled) return;

    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var defaultLabel = btn.getAttribute('data-default-label') || 'Add to cart';

    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch((window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (!response.ok) {
          return response.json().then(function (content) {
            throw new Error((content && content.description) || 'Could not add to cart');
          });
        }
        return response.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = 'Added ✓';

        btn.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: 1 }
        }));
        document.dispatchEvent(new CustomEvent('cart:updated'));

        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = defaultLabel;
          btn.disabled = false;
        }, RESET_DELAY);
      })
      .catch(function (err) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        btn.classList.remove('is-loading');
        btn.textContent = (err && err.message) || 'Try again';

        setTimeout(function () {
          btn.textContent = defaultLabel;
          btn.disabled = false;
        }, RESET_DELAY);
      });
  });
})();
